class ColibriMobileMenu extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    this.closeButtons = this.querySelectorAll('[data-colibri-menu-close]');

    if (!this.details) return;

    this.onToggle = this.onToggle.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.close = this.close.bind(this);

    this.details.addEventListener('toggle', this.onToggle);
    this.closeButtons.forEach((button) => button.addEventListener('click', this.close));
    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    this.details?.removeEventListener('toggle', this.onToggle);
    this.closeButtons?.forEach((button) => button.removeEventListener('click', this.close));
    document.removeEventListener('keydown', this.onKeydown);
    this.setPageLocked(false);
  }

  onToggle() {
    this.setPageLocked(this.details.open);
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.details.open) this.close();
  }

  close() {
    this.details.open = false;
    this.querySelector('summary')?.focus();
  }

  setPageLocked(locked) {
    document.documentElement.classList.toggle('colibri-mobile-menu-open', locked);
    document.body.classList.toggle('colibri-mobile-menu-open', locked);
  }
}

if (!customElements.get('colibri-mobile-menu')) {
  customElements.define('colibri-mobile-menu', ColibriMobileMenu);
}
